module.exports = __webpack_public_path__ + "static/media/mmm-pin.24cc8ee8.svg";